import {
    Platform
} from "react-native";
import {
    AuthProvider
} from "./contexts/AuthContext";
import DriveUploadProvider from "./contexts/driveUpload";
import Navigation from "./navigation";
import defaultLocaleJSON from "./variants/locales/default.json";
import defaultThemeJSON from "./variants/themes/default.json";
import {
    type NCoreUIKitConfig,
    setupNCoreUIKit,
    Host
} from "ncore-ui-kit";
import "moment/locale/tr";
import moment from "moment";

let NCoreConfig: NCoreUIKitConfig = {
    initialSelectedGapPropagation: "spacious",
    initialSelectedActiveSharpness: "soft",
    projectLocales: defaultLocaleJSON,
    initialSelectedPalette: "gmcore",
    projectThemes: defaultThemeJSON,
    initialSelectedLocale: "tr-TR",
    initialSelectedTheme: "light"
};

const themeStorage = Platform.OS === "web" ? window.localStorage.getItem("theme") : null;

if (themeStorage) {
    const parsedThemeStorage = JSON.parse(themeStorage);

    NCoreConfig = {
        ...NCoreConfig,
        initialSelectedGapPropagation: parsedThemeStorage.activeGapPropagation,
        initialSelectedActiveSharpness: parsedThemeStorage.activeSharpness,
        initialSelectedTheme: parsedThemeStorage.activeTheme
    };
}

const localeStorage = Platform.OS === "web" ? window.localStorage.getItem("locale") : null;

if (localeStorage) {
    try {
        const parsedLocaleStorage = JSON.parse(localeStorage);

        NCoreConfig = {
            ...NCoreConfig,
            initialSelectedLocale: parsedLocaleStorage.activeLocale || parsedLocaleStorage
        };
    } catch {
        NCoreConfig = {
            ...NCoreConfig,
            initialSelectedLocale: localeStorage as keyof NCoreUIKit.LocaleKey
        };
    }
}

if (Platform.OS === "web") {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get("lang");

    if (langParam) {
        const isValidLocale = defaultLocaleJSON.some(item => item.locale === langParam);

        if (isValidLocale) {
            NCoreConfig.initialSelectedLocale = langParam as keyof NCoreUIKit.LocaleKey;
        }
    }

    if (!NCoreConfig.initialSelectedLocale) {
        const browserLang = window.navigator.language || "";

        const exactMatch = defaultLocaleJSON.find(item => item.locale === browserLang);

        if (exactMatch) {
            NCoreConfig.initialSelectedLocale = exactMatch.locale as keyof NCoreUIKit.LocaleKey;
        } else {
            const primaryLang = (browserLang.split(/[-_]/)[0] || "").toLowerCase();

            const similarMatch = defaultLocaleJSON.find(item =>
                item.locale.toLowerCase() === primaryLang ||
                item.locale.toLowerCase().startsWith(`${primaryLang}-`)
            );

            if (similarMatch) {
                NCoreConfig.initialSelectedLocale = similarMatch.locale as keyof NCoreUIKit.LocaleKey;
            } else {
                NCoreConfig.initialSelectedLocale = (primaryLang === "tr" ? "tr-TR" : "en-US") as keyof NCoreUIKit.LocaleKey;
            }
        }
    }
}

const NCoreUIKitBase = setupNCoreUIKit(NCoreConfig);

moment.locale("tr");

const App = () => {
    return <Navigation />;
};

const ContextAPI = () => {
    return <AuthProvider>
        <NCoreUIKitBase.Provider>
            <Host
                name="main-header"
            >
                <DriveUploadProvider>
                    <App />
                </DriveUploadProvider>
            </Host>
        </NCoreUIKitBase.Provider>
    </AuthProvider>;
};
export default ContextAPI;
